import { Tooltip, Tag, HStack, Box } from '@chakra-ui/react';
import { CellProps } from '../../../types';
import { hasPerm, P } from '../../../../../../utilities/roles/permissions';
import { getAllTags, sortWIthIntakeFirst } from '../../../../../../utilities/tags';
import { UserRole } from '../../../../../../store/auth/types';
import { TagComponent } from '@/components/molecules/Tags';
import { ITag } from 'api-paths-cas';
import { isRemovableTag } from 'shared-components';

export type ProcessingMode = 'Offer' | 'Intake'; // this needs to be moved to types package

export const Tags = ({ cellProps, role, isPathway }: { cellProps: CellProps; role: UserRole; isPathway?: boolean }) => {
  const { tags } = cellProps.row;

  const canDelete = hasPerm(role, P.TAGS_DELETE);

  let allTags = getAllTags({
    tags,
    isPathway,
  });
  allTags = sortWIthIntakeFirst(allTags);

  return (
    <HStack spacing={1} w="full">
      {allTags.slice(0, 3).map((tag: ITag, idx: number) => {
        return (
          <TagComponent
            key={idx}
            tag={tag}
            onClick={() => cellProps.row.onTagDelete!(tag.id, tag.type as any, cellProps.row)}
            canDelete={canDelete && isRemovableTag(tag)}
          />
        );
      })}
      {allTags.length > 3 && (
        <Tooltip
          hasArrow
          placement="bottom"
          label={
            <Box textAlign="left">
              {allTags.slice(3, allTags.length).map((tag: ITag, index: number) => (
                <div key={index}>{tag.label}</div>
              ))}
            </Box>
          }
        >
          <Tag
            size="xs"
            variant="subtle"
            bgColor="utility.100"
            _dark={{
              bgColor: 'whiteAlpha.200',
              color: 'whiteAlpha.800',
            }}
          >
            +{allTags.length - 3}
          </Tag>
        </Tooltip>
      )}
    </HStack>
  );
};
